function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.8875 0H2.8875C1.3125 0 0 1.3125 0 2.8875V32.1125C0 33.6875 1.3125 35 2.8875 35H16.8875C18.4625 35 19.775 33.6875 19.775 32.1125V2.8875C19.775 1.3125 18.4625 0 16.8875 0ZM2.625 9.3625H17.0625C17.0625 9.3625 17.0625 9.3625 17.15 9.3625V25.025C17.0625 25.025 16.975 25.025 16.8875 25.025H2.8875C2.8 25.025 2.7125 25.025 2.625 25.025V9.3625ZM2.8875 2.625H16.8875C17.0625 2.625 17.15 2.7125 17.15 2.8875V6.7375C17.15 6.7375 17.15 6.7375 17.0625 6.7375H2.7125C2.7125 6.7375 2.7125 6.7375 2.625 6.7375V2.8875C2.625 2.7125 2.7125 2.625 2.8875 2.625ZM16.8875 32.375H2.8875C2.7125 32.375 2.625 32.2875 2.625 32.1125V27.5625C2.7125 27.5625 2.8 27.5625 2.8875 27.5625H16.8C16.8875 27.5625 16.975 27.5625 17.0625 27.5625V32.1125C17.15 32.2875 17.0625 32.375 16.8875 32.375Z",
  fill: "url(#paint16_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.88743 28.35C9.09993 28.35 8.48743 28.9625 8.48743 29.75C8.48743 30.45 9.09993 31.15 9.88743 31.15C10.6749 31.15 11.2874 30.5375 11.2874 29.75C11.2874 28.9625 10.6749 28.35 9.88743 28.35Z",
  fill: "url(#paint17_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 9.8875,
  y1: 0,
  x2: 9.8875,
  y2: 35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 9.88743,
  y1: 28.35,
  x2: 9.88743,
  y2: 31.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.775,
  height: 35,
  fill: "white"
})));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 35,
    viewBox: "0 0 20 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.76c6cb6e.svg";
export { ForwardRef as ReactComponent };